import React from "react";
import { Text } from "@mantine/core";

export default function OdometerValueMismatch({ originalValue, newValue }) {
  if (originalValue === 0 && newValue && newValue !== "0") {
    return (
      <Text mt="md" size="xs" align="center" c="yellow" fw={600}>
        This number doesn't match the customer's number. Please double-check the
        reading before you submit!
      </Text>
    );
  }
  if (
    newValue &&
    originalValue &&
    newValue.replace(/^0+/, "") !== `${originalValue}`
  ) {
    return (
      <Text mt="md" size="xs" align="center" c="yellow" fw={600}>
        This number doesn't match the customer's number. Please double-check the
        reading before you submit!
      </Text>
    );
    // return (
    //   <Text mt="sm" size="xs" align="center" c="red" fw={600}>
    //     Customer entered odometer reading: <span>{originalValue}</span>.
    //     <br />
    //     Your reading and their reading do not match!
    //   </Text>
    // );
  } else {
    return null;
  }
}
